module.exports = __webpack_public_path__ + "static/media/footer_2.5bbe3972.png";